import { types } from '../../../types/types';

export const getCredencialReducer = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.CREDENCIAMENTO.GET_CREDENCIAL:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const pesquisaCadastroReducer = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.CREDENCIAMENTO.PESQUISA_CADASTRO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}

export const pesquisaCredencialComPedidoReducer = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.CREDENCIAMENTO.PESQUISA_CADASTRO_COM_PEDIDO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}